import slugify from "slugify";
import {
    b64Uri,
    getData,
    getJson,
    resetSelect2Ajax,
} from "../../../../../helpers";
import { filter } from "../../../../../components/selectCategory";

export const storePost = () => {
    addEvents();
    loadCategories();
};

const addEvents = () => {
    const Form = document.querySelector("[data-current-section=storePost]");
    const CntCategories = document.querySelector("#cntCategories");
    const InpTitle = Form.elements.title;
    const BtnSavePost = Form.elements.btnSave;
    const Image = Form.elements.image;

    InpTitle.addEventListener("input", (e) => {
        const numberElement = document.querySelectorAll(
            "[data-paste=" + getData(InpTitle, "data-copy") + "]"
        );

        numberElement.forEach((element) => {
            element.value = slugify(InpTitle.value, {
                replacement: "-",
                lower: true,
            });
        });
    });

    BtnSavePost.addEventListener("click", () => {
        // Realizar comprobación del slug por fecth
        if (validateCategories() & Form.reportValidity()) {
            Form.submit();
        }
    });

    Form.addEventListener("aj:select2", (e) => {
        if (!filter.categories.some((item) => item.id === e.detail.data.id)) {
            filter.categories.push(e.detail.data);
        }

        listCategories();

        resetSelect2Ajax(e.target);
    });

    CntCategories.addEventListener("click", (e) => {
        const C = e.target.closest(".category");

        if (C) {
            filter.categories = filter.categories.filter(
                (item) => item.id != C.id
            );

            listCategories();
        }
    });

    Image.addEventListener("input", (e) => {
        // if ("input" != e.target.nodeName.toLowerCase()) return; // usar esto para detener la propagación en el evento click

        const Target = e.target;

        const Img = Target.files[0];

        if (Img) {
            // if (Img.type != "image/jpeg" && Img.type != "image/png") {
            //     showMessageAdmin("La imagen puede ser de tipo jpg o png", "error");
            //     Target.value = "";
            // } else {
            let dataImage = new FileReader();
            dataImage.readAsDataURL(Img);

            dataImage.addEventListener("loadend", () => {
                let imageSrc = dataImage.result;

                Image.parentElement.nextElementSibling.setAttribute(
                    "src",
                    imageSrc
                );
            });
            // }
        }
    });
};

const listCategories = () => {
    const CntCategories = document.querySelector("#cntCategories");

    CntCategories.innerHTML = "";

    filter.categories.forEach((item) => {
        CntCategories.innerHTML += `<span class="badge bg-primary text-truncate flex-grow-1 me-1 category" role="button" id="${item.id}">${item.name}</span>`;
    });

    if (!filter.categories.length) {
        CntCategories.innerHTML = `<span>${getData(
            CntCategories,
            "data-lang"
        )}</span>`;
    }

    const C = CntCategories.nextElementSibling;

    C.value = b64Uri(filter.categories);
};

const validateCategories = () => {
    const Form = document.querySelector("[data-current-section=storePost]");
    const C = Form.elements.categories;
    const Category = Form.elements.category_id;

    let validate = false;
    Category.setAttribute("required", "");

    if (C.value) {
        const Categories = getJson(b64Uri(C.value, "decode"));

        if (Categories.length) {
            validate = true;
            Category.removeAttribute("required");
        }
    }

    return validate;
};

const loadCategories = () => {
    const Form = document.querySelector("[data-current-section=storePost]");
    const Categories = Form.elements.categories;

    if (parseInt(getData(Categories, "data-post"))) {
        filter.categories = getJson(b64Uri(Categories.value, "decode"));
    }
};
